import { CruiseService } from '../../services/cruise.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  showDropDown: boolean = false;
  title = 'Cruize'; public loginType = ''; public balancestr: any = 0; public username = ''; private loginDataN: any = {};
  public usertype = ''; private agentcode = ''; public imageURL = ''; public link = ''; private logindata: any = ''; public last_access: Date;
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private cruiserService: CruiseService, private router: Router, private toastr: ToastrService) {
    this.loginType = this.cruiserService.getloginType();
    try {
      if (isPlatformBrowser(this.platformId)) {
        if (this.loginType == "B2B") {
          this.logindata = sessionStorage.getItem("logindata");
          this.loginDataN = JSON.parse(JSON.parse(this.logindata));
          this.balancestr = this.loginDataN.CurrentBalance;
          this.username = this.loginDataN.AgencyName;
          this.usertype = this.loginDataN.Type;
          this.agentcode = this.loginDataN.CompanyCode;
          this.link = this.loginDataN.Link;
          this.imageURL = "https://s3.ap-south-1.amazonaws.com/b2badminstorage/AGENT_LOGO/" + this.agentcode + ".png?" + Math.round((Math.random() * 100000) * 100);
        }
      }
    } catch (errormsg) { }

    // get the merchant data
    this.getMerchantData();
  }

  ngOnInit() {
    // Check for last access if it is more than 30 mins then expire session
    if (this.loginType == "B2B") {
      if (isPlatformBrowser(this.platformId)) {
        if (sessionStorage.getItem("last_access")) {
          this.last_access = new Date(Number(sessionStorage.getItem("last_access")));
          var diff = this.diff_minutes(this.last_access, new Date());
          if (diff > 20) {
            sessionStorage.clear();
            this.toastr.warning("You session expired, Pl login again...!");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        } else {
          var d = new Date();
          sessionStorage.setItem("last_access", JSON.stringify(d.getTime()));
        }
      }
    }

  }

  diff_minutes(dt2: Date, dt1: Date) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  logout() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear(); sessionStorage.clear();
    }
    // setTimeout(() => {
    //   this.router.navigate(["https://agents.akbartravelsonline.com/MyAccount/Login"]);
    // }, 2000);
  }

  getMerchantData() {
    if (!sessionStorage.getItem("merchantData")) {
      this.cruiserService.getHomePageData("").subscribe(
        data => {
          let resp = JSON.parse(JSON.stringify(data)).d;
          resp = JSON.parse(this.cruiserService.getdecryptData(resp));
          sessionStorage.setItem("merchantData", JSON.stringify(resp));
        },
        error => {
          console.log(error);
        }
      )
    }
  }
}
